import React from 'react';
import { Button, ModalBody, ModalFooter, Text } from '@chakra-ui/react';
import { MdOutlineCancel } from 'react-icons/md';
import { IoMdCheckmark } from 'react-icons/io';

// `prompt` accepts either a string (rendered in a default Text) or any React
// node — useful for richer content like review cards.
const ConfirmModal = ({ handleCancel, handleSubmit, isLoading, prompt }) => {
  return (
    <ModalBody>
      {typeof prompt === 'string' || typeof prompt === 'number' ? (
        <Text color={'white'}>{prompt}</Text>
      ) : (
        prompt
      )}
      <ModalFooter justifyContent={'center'} gap={4}>
        {handleCancel && (
          <Button
            colorScheme={'red'}
            size="sm"
            bg="black"
            border={'2px solid'}
            borderColor={'whiteAlpha.500'}
            borderRadius={'lg'}
            onClick={(e) => handleCancel(e)}
            leftIcon={<MdOutlineCancel size={'1rem'} />}
            p={3}
          >
            Cancel
          </Button>
        )}
        <Button
          colorScheme={'brand'}
          p={3}
          size="sm"
          bg="black"
          border={'2px solid'}
          borderColor={'whiteAlpha.500'}
          borderRadius={'lg'}
          leftIcon={<IoMdCheckmark size={'1rem'} />}
          type="submit"
          onClick={handleSubmit}
          isLoading={isLoading}
        >
          Confirm
        </Button>
      </ModalFooter>
    </ModalBody>
  );
};

export default ConfirmModal;
